import { tagStyle } from "@/data/styles"
import clsx from "clsx";
import Image from "next/image";

type DefaultCardProps = Partial<{
  labels: string[]
  title: string
  subtitle: string
  caption: string
  image: string
}>

export default function DefaultCard({ labels, title, subtitle, caption, image }: DefaultCardProps) {
  return (
    <div className="flex flex-col text-[#302e2d]">
      <div className="relative w-[260px] h-[280px] sm:w-[324px] sm:h-[323px] rounded-[4px] bg-[#EBE1D4] mb-[10px]">
        {labels && labels.length > 0 && (
          <div className="absolute top-[16px] flex flex-wrap gap-x-[5px] gap-y-[11px] z-10 px-[17px] w-full">
            {labels.map((label, i) => (
              <span key={i} className={clsx(tagStyle, "bg-[#FBFAF9]/70 text-[#1B1D2B] px-[10px] rounded-[10px]" )} >
                {label}
              </span>
            ))}
          </div>
        )}
        {image && <Image src={image} alt={title ?? "Image"} className="object-cover rounded-lg" fill />}
      </div>

      {title && (
        <h2 title={title} className="font-normal text-[20px] sm:text-[24px] leading-[28px] sm:leading-[34px] truncate max-w-[65vw] sm:max-w-[324px] mb-[5px]">
          {title}
        </h2>
      )}
      {subtitle && (
        <p title={subtitle} className="font-normal text-[14px] sm:text-[16px] leading-[22px] sm:leading-[26px] text-[#6a6867] truncate max-w-[65vw] sm:max-w-[324px]">
          {subtitle}
        </p>
      )}
      {caption && (
        <p className="font-normal text-[14px] sm:text-[16px] leading-[22px] sm:leading-[26px]">
          {caption}
        </p>
      )}
    </div>
  )
}